import { useEffect, useRef } from 'react';

export type UseIntervalProps = {
  isRunning?: boolean;
  delay?: number;
  fn?: () => void;
};

export const useInterval = (options: UseIntervalProps = {}) => {
  const { isRunning = false, delay = 1000, fn } = options || {};
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        fn?.();
      }, delay);
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRunning, delay]);

  return { intervalRef };
};
